import React from 'react';

function AdminHome() {
	return (
		<div className='w-full h-full flex  justify-center pt-20 '>
			<p className='px-40 text-center text-xl'>
				Ljudsko interesovanje i znanje obuhvataju širok spektar kategorija koje se mogu podeliti na različite oblasti i tematske grupe. Ovde su osnovne kategorije ljudskog interesovanja i
				znanja
			</p>
		</div>
	);
}

export default AdminHome;
